import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { GatheringRequests } from 'src/requests/gathering';
import { QueryKey } from 'src/utils/react-query';
import type { IGatheringChatItem } from '../../types';
import { editMessage } from '../utils';

export const useGatheringChatMessageReactMutation = () => {
  const queryClient = useQueryClient();
  const { mutate: reactGatheringChatMessage, isLoading: isReacting } =
    useMutation({
      mutationFn: GatheringRequests.reactGatheringChatMessage,
      onSuccess(data) {
        queryClient.setQueryData<InfiniteData<IGatheringChatItem[]>>(
          [QueryKey.GATHERING, data.sessionRef, 'chatMessages'],
          (currentData) => currentData && editMessage(currentData, data),
        );
      },
    });

  return {
    isReacting,
    reactGatheringChatMessage,
  };
};
